<template>
  <div v-if="activityInfo">
    <div id="creatImgBefore" v-show="creatImgBeforeshow">
      <img id="bgimg" :src="`${activityInfo.activitySharePicture}?time=${new Date().valueOf()}`" crossorigin="anonymous"
        alt />
      <div id="qrcode"></div>
    </div>
    <div class="creatImgAfter" v-show="canvasImgShow && !this.$root.miniprogram" @touchmove.prevent>
      <div class="canvasImg">
        <img @click="canvasImgShow = false" class="close" src="@/assets/img/pullNew/close.png" alt />
        <img class="userImg" :src="dataUrl" alt />
        <p class="tips">长按保存或截图分享至朋友圈/微信群</p>
      </div>
    </div>
    <div class="creatImgAfter" v-show="canvasImgShow && this.$root.miniprogram" @touchmove.prevent>
      <div class="canvasImg canvasImgInMINI">
        <img class="guideImg" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/guide.png" alt />
        <img @click="canvasImgShow = false" class="close"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/closeText.png" alt />
        <img class="userImg" :src="dataUrl" alt />
        <p class="tips">长按保存或截图分享至朋友圈/微信群</p>
      </div>
    </div>
  </div>
</template>
<script>
import loadJS from 'load-js';
import html2canvas from 'html2canvas';
import { pushShareStatusApi } from '@/api/pullNew';

export default {
  props: {
    activityInfo: {
      type: Object,
    },
  },
  data() {
    return {
      dataUrl: null,
      canvasImgShow: false,
      creatImgBeforeshow: false,
      isCreateCanvas: false, // 生成canvas防止多次点击
      isCreatQrCode: false, // 生成二维码防止多次点击
    };
  },
  methods: {
    createImg() {
       this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { activityId, pullNewActivityShareData = {} } = this.activityInfo;
      const { encryptionKey } = pullNewActivityShareData;
      if (this.dataUrl) {
        this.canvasImgShow = true;
        this.$toast.clear();
        return;
      }
      if (!encryptionKey) {
        this.$toast.fail('缺少参数，不能生成分享图');
        this.$toast.clear();
        return;
      }
      this.creatImgBeforeshow = true;
      loadJS([
        {
          async: false,
          url: 'https://image-prod.iqihang.com/public/js/qrcode.min.js',
        },
      ]).then(() => {
        this.creatQrCode(activityId, encryptionKey);
        setTimeout(() => {
          this.createCanvas();
        }, 500);
      });
    },
    creatQrCode(activityId, encryptionKey) {
      if (this.isCreatQrCode) return;
      this.isCreatQrCode = true;
      const url = `${window.location.origin}/ark/pullnew/helper/?activityId=${activityId}&key=${encryptionKey}&pullNewType=${this.$root.pullNewType===2||this.$root.ytMini?'yt':''}`;
      console.log('创建二维码', url);
      // eslint-disable-next-line no-new, no-undef
      new QRCode(document.getElementById('qrcode'), {
        text: url,
        render: 'table',
        // render:"canvas",
        width: 80,
        height: 80,
        typeNumber: -1, // 计算模式
        correctLevel: 0, // 纠错等级   correctLevel
      });
      console.log('创建二维码成功了', document.getElementById('qrcode'));
      setTimeout(() => {
        this.isCreatQrCode = false;
      }, 2000);
    },
    createCanvas() {
      if (this.isCreateCanvas) return;
      this.isCreateCanvas = true;
      html2canvas(document.getElementById('creatImgBefore'), {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent', // 圆角问题
      }).then((canvas) => {
        this.imgBeforeShow = false;
        const dataURL = canvas.toDataURL('image/png', 1.0);
        this.dataUrl = dataURL;
        this.canvasImgShow = true;
        this.pushShareStatus();
        this.creatImgBeforeshow = false;
        this.$toast.clear();
      });
      setTimeout(() => {
        this.isCreateCanvas = false;
      }, 2000);
    },
    pushShareStatus() {
      // 更新用户是否分享过
      pushShareStatusApi(this.activityInfo.activityId);
    },
  },
};
</script>
<style scoped lang="scss">
#creatImgBefore {
  position: fixed;
  top: 100px;
  top: 50%;
  left: 0;
  left: 50%;
  z-index: -2;
  width: 600px;
  height: 1000px;
  transform: translate(-50%, -50%);

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  #qrcode {
    position: absolute;
    bottom: 38px;
    left: 54px;
    z-index: 1;
    width: 164px;
    height: 164px;
    canvas,img {
      width: 100%;
      height: 100%;
    }
  }
}

.creatImgAfter {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  .canvasImg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 600px;
    height: 1000px;
    transform: translate(-50%, -50%);
    .guideImg {
      width: 598px;
      height: 142px;
    }
    .userImg {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }

    .close {
      position: absolute;
      top: 24px;
      right: 24px;
      width: 48px;
      height: 48px;
    }

    .tips {
      width: 600px;
      height: 64px;
      margin-top: 30px;
      color: #fff;
      font-size: 24px;
      line-height: 64px;
      text-align: center;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 16px;
    }
  }

  .canvasImgInMINI {
    top: 0;
    transform: translate(-50%, 0);

    .close {
      position: absolute;
      top: 70px;
      right: 38px;
      width: 126px;
      height: 50px;
    }
  }
}</style>
